/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChildDto } from '../../models/child-dto';

export interface UserChildControllerFindById$Params {
  id: string;

/**
 * 예외처리 여부
 */
  passException?: boolean;
}

export function userChildControllerFindById(http: HttpClient, rootUrl: string, params: UserChildControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<ChildDto>> {
  const rb = new RequestBuilder(rootUrl, userChildControllerFindById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('passException', params.passException, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ChildDto>;
    })
  );
}

userChildControllerFindById.PATH = '/api/child/user/{id}';
